import { useAuth } from '@/contexts/ContextoAuth';
import { useWorkspace } from '@/contexts/ContextoWorkspace';

/**
 * Orden único de las ventanas que aparecen al entrar por primera vez:
 * régimen tributario → cambio de contraseña → bienvenida → tour guiado.
 * Cada ventana solo se muestra cuando las anteriores ya no están pendientes.
 */
export function useVentanasIniciales() {
  const { isAuthenticated, user } = useAuth();
  const { currentEmpresa, hasContext } = useWorkspace();

  const bienvenidaPendiente = !!user?.esOnboarding;
  const regimenPendiente = isAuthenticated && hasContext && !!currentEmpresa && !currentEmpresa.regimenTributario;
  const passwordPendiente = !!user?.esCreadoPorApiKey && !!user?.requiereCambioPassword;

  return {
    mostrarRegimen: regimenPendiente,
    mostrarPassword: passwordPendiente && !regimenPendiente,
    mostrarBienvenida: bienvenidaPendiente && !regimenPendiente && !passwordPendiente,
    ventanasPendientes: bienvenidaPendiente || regimenPendiente || passwordPendiente,
  };
}
